<div aria-live="polite" aria-atomic="true" class="position-relative">
  <div class="toast-container position-fixed top-0 end-0 p-3">
    <div
      *ngFor="let toast of toasts"
      class="toast show"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      [ngStyle]="{
        'background-color': toast.backgroundColor,
        'border-color': toast.borderColor
      }"
    >
      <div class="toast-header">
        <i [ngClass]="toast.iconClass" class="me-2" [ngStyle]="{ color: toast.iconColor }"></i>
        <strong class="me-auto" [ngStyle]="{ color: toast.titleColor }">
          {{ toast.title }}
        </strong>
        <button type="button" class="btn-close" (click)="remove(toast.id)" aria-label="Close"></button>
      </div>

      @if(toast.message){
      <div class="toast-body" [ngStyle]="{ color: toast.bodyColor }">
        {{ toast.message }}
      </div>
      }
    </div>
  </div>
</div>
